// Shared helpers for the service reminders UI.
import React from 'react';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import { normalizeLanguage } from '../../utils/languages';
import { TONE } from '../shared/designKit';

export const triggerLabel = (catalog, key, language) => {
  const trigger = catalog?.triggers?.find((item) => item.key === key);
  if (!trigger) return key;
  return trigger[`label_${normalizeLanguage(language)}`] || trigger.label_fi;
};

// Skip reasons come from the backend as fixed slugs — translate via this map so
// the audit view explains WHY in plain Finnish (support question #1).
export const skipReasonTranslationKey = (reason) => `service_reminders.skip_${reason}`;

export const channelTranslationKey = (channel) => `service_reminders.channel_${channel}`;

// The list views and the segmented control: "Sähköposti, muuten tekstiviesti" instead of the
// full sentence the radio group used to carry.
export const channelShortTranslationKey = (channel) =>
  channel === 'email_else_sms' ? 'service_reminders.channel_short_email_else_sms' : channelTranslationKey(channel);

export const statusTranslationKey = (status) => `service_reminders.status_${status}`;

// Send status as a tag tone: sent green, queued blue, skipped grey, failed red.
export const STATUS_TONE = {
  sent: TONE.green,
  scheduled: TONE.accent,
  skipped: TONE.slate,
  failed: TONE.red,
};

export const channelIcon = (channel, sx) => {
  if (channel === 'sms') return <SmsOutlinedIcon sx={sx} />;
  if (channel === 'email_else_sms') return <ForwardToInboxOutlinedIcon sx={sx} />;
  return <EmailOutlinedIcon sx={sx} />;
};

export const formatCost = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (Number.isNaN(num)) return '';
  return `${num.toFixed(2).replace('.', ',')} €`;
};
